export { comparePathPriority } from './comparePathPriority'
